import React, {Component} from 'react';
import './ErrorIndicator.css';

export class ErrorIndicator extends Component {
    render() {
        return (<div>Error</div>)
    }
}